import { InfoOutlinedIcon } from '../../components';
import cn from '../../lib/classNames';

import styles from './TooltipIcon.module.scss';

export default function TooltipIcon() {
	return <InfoOutlinedIcon className={cn(styles.icon, 'icons-animation')} fontSize="large" />;
}
